import React, { Fragment } from "react";
import useFeatureFlag from "../../hooks/FeatureFlag"

export default function FeatureFlag(props) {
  const { flagStatus } = useFeatureFlag(props);

  return flagStatus && <Fragment>{props.children}</Fragment>;
}
